import React from 'react';
import PropTypes from 'prop-types';
import { Image, Link, TrustpilotWidget } from 'components';
import { media } from 'utils/media';
import content from 'cms/content/press.yml';
import isExternalUrl from "../utils/isExternalUrl";

const Press = ({ home }) => {
  if(!content.enabled) return false;

  const pressItems = [];
  content.images.forEach(function(item, index) {
    pressItems.push(
      <Link to={item.link} key={index} className='icon-press _maxw12' external={isExternalUrl(item.link)}>
        <Image url={media(item.image)} alt={item.name} />
      </Link>
    )
  });

  return (
    <div className='section-icons-press'>
      <div className='trustpilot-pattern'>
        <TrustpilotWidget isHomepage={home} />
      </div>
      <div className='icons-press-wrapper'>
        {pressItems}
      </div>
    </div>
  );
};

Press.propTypes = {
  home: PropTypes.bool
};

export default Press;